// خريطة أزرار يومي/أسبوعي/شهري → قيم resolvePreset.
// أسبوع/شهر تقويمي يُصفَّر ويبدأ من جديد (لا نافذة متحركة):
//   week  → "this_week"  = بداية الأسبوع التقويمي الحالي (الأحد) → اليوم
//   month → "this_month" = اليوم الأول من الشهر التقويمي الحالي → اليوم
// وحدة مستقلّة بلا استيراد ثقيل ليتمكّن الاختبار من استعمالها مباشرة.
export const GRAIN_PRESET = { day: "today", week: "this_week", month: "this_month" };

// يحسم نافذة القياس الفعلية: التاريخ اليدوي (إن وُجد أي طرف) يطغى على
// القيمة المسبقة (يومي/أسبوعي/شهري). دالة نقيّة قابلة للاختبار.
export const resolveGrainWindow = (presetRange, manualStart, manualEnd) => {
  const manualActive = Boolean(manualStart || manualEnd);
  return manualActive
    ? { from: manualStart, to: manualEnd, manual: true }
    : { from: presetRange?.from || "", to: presetRange?.to || "", manual: false };
};
